// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import 'bootstrap/dist/css/bootstrap.min.css';

// const ProfilePage = () => {
//   const navigate = useNavigate();
//   const [user, setUser] = useState(null);
//   const [appointments, setAppointments] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [activeTab, setActiveTab] = useState('appointments');

//   // --- Modal States ---
//   const [showDetailsModal, setShowDetailsModal] = useState(false);
//   const [selectedAppt, setSelectedAppt] = useState(null);

//   // --- Edit Profile Form ---
//   const [formData, setFormData] = useState({
//     name: '', phone: '', address: '', gender: '', dob: '', image: ''
//   });

//   useEffect(() => {
//     const userString = localStorage.getItem('DDoctorUser');
//     if (!userString) {
//       navigate('/');
//       return;
//     }
//     const userData = JSON.parse(userString);
//     setUser(userData);

//     setFormData({
//       name: userData.name || '',
//       phone: userData.phone || '',
//       address: userData.address || userData.city || '',
//       gender: userData.gender || '',
//       dob: userData.dob || '',
//       image: userData.image || ''
//     });

//     fetchAppointments(userData._id);
//   }, [navigate]);

//   const fetchAppointments = (userId) => {
//     // FIX 1: URL fixed (removed quotes around process.env)
//     axios.get(`${process.env.REACT_APP_API_BASE_URL}/bookings/user/${userId}`)
//       .then(res => {
//         // FIX 2: Safely extract the array. Handle both [..] and { data: [..] }
//         const list = Array.isArray(res.data) ? res.data : (res.data.data || []);
//         setAppointments(list);
//         setLoading(false);
//       })
//       .catch(err => {
//         console.error("Error fetching appointments:", err);
//         // FIX 3: Set empty array on error so .filter doesn't crash
//         setAppointments([]); 
//         setLoading(false);
//       });
//   };

//   // --- Actions ---
//   const handleCancelAppointment = (apptId) => {
//     if (window.confirm("Are you sure you want to cancel this appointment?")) {
//       // FIX 1: URL fixed
//       axios.put(`${process.env.REACT_APP_API_BASE_URL}/bookings/cancel/${apptId}`)
//         .then(res => {
//           alert("Appointment Cancelled.");
//           fetchAppointments(user._id);
//           setShowDetailsModal(false);
//         })
//         .catch(err => alert("Error cancelling appointment"));
//     }
//   };

//   const openDetailsModal = (appt) => {
//     setSelectedAppt(appt);
//     setShowDetailsModal(true);
//   };

//   // --- Profile Updates ---
//   const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

//   const handleImageUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.readAsDataURL(file);
//       reader.onloadend = () => setFormData({ ...formData, image: reader.result });
//     }
//   };

//   const handleUpdateProfile = (e) => {
//     e.preventDefault();
//     // FIX 1: URL fixed
//     axios.put(`${process.env.REACT_APP_API_BASE_URL}/users/update/${user._id}`, formData)
//       .then(res => {
//         alert("Profile Updated Successfully!");
//         const updatedUser = res.data.user || res.data; // Handle wrapper
//         localStorage.setItem('DDoctorUser', JSON.stringify(updatedUser));
//         setUser(updatedUser);
//       })
//       .catch(err => alert("Error updating profile."));
//   };

//   // --- STYLES FOR ACTION BOXES ---
//   const actionBoxStyle = {
//     cursor: 'pointer',
//     transition: 'transform 0.2s, box-shadow 0.2s',
//     minWidth: '140px'
//   };

//   if (loading) return <div className="text-center mt-5 pt-5"><div className="spinner-border text-primary"></div></div>;
//   if (!user) return null; // Safety check

//   return (
//     <div className="container py-5" style={{ marginTop: '20px' }}>

//       {/* --- HEADER SECTION WITH ACTION BUTTONS --- */}
//       <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-5 gap-3">

//         {/* Left: Welcome Text */}
//         <div>
//           <h2 className="fw-bold text-dark mb-0">Patient Dashboard</h2>
//           <p className="text-muted">Welcome back, {user.name}</p>
//         </div>

//         {/* Right: Action Boxes (Discount & Reports) */}
//         <div className="d-flex gap-3">
//           {/* 1. Medical Reports Box */}
//           <div
//             className="card border-0 shadow-sm p-3 text-center align-items-center justify-content-center bg-white"
//             style={actionBoxStyle}
//             onClick={() => navigate('/medical-records')}
//             onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
//             onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
//           >
//             <div className="mb-2 text-primary">
//               <i className="bi bi-file-earmark-medical-fill fs-2"></i>
//             </div>
//             <h6 className="fw-bold mb-0 text-dark" style={{ fontSize: '14px' }}>Medical<br />Records</h6>
//           </div>

//           {/* 2. Discount Card Box */}
//           <div
//             className="card border-0 shadow-sm p-3 text-center align-items-center justify-content-center bg-white"
//             style={actionBoxStyle}
//             onClick={() => navigate('/discount-card')}
//             onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
//             onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
//           >
//             <div className="mb-2 text-danger">
//               <i className="bi bi-credit-card-2-front-fill fs-2"></i>
//             </div>
//             <h6 className="fw-bold mb-0 text-dark" style={{ fontSize: '14px' }}>Discount<br />Card</h6>
//           </div>
//         </div>

//       </div>

//       <div className="row">
//         {/* --- LEFT SIDEBAR --- */}
//         <div className="col-md-4 mb-4">
//           <div className="card shadow-sm border-0 p-4 text-center bg-white h-100">
//             <div className="mb-3 mx-auto rounded-circle overflow-hidden d-flex align-items-center justify-content-center bg-light" style={{ width: '120px', height: '120px' }}>
//               {user.image ? (
//                 <img src={user.image} alt="Profile" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
//               ) : (
//                 <i className="bi bi-person-fill fs-1 text-secondary"></i>
//               )}
//             </div>
//             <h4 className="fw-bold text-capitalize mb-1">{user.name}</h4>
//             <p className="text-muted small mb-3">{user.email}</p>

//             <div className="d-flex justify-content-around w-100 mt-3 border-top pt-3">
//               <div className="text-center">
//                 <h5 className="fw-bold mb-0">{appointments.length}</h5>
//                 <small className="text-muted">Total Bookings</small>
//               </div>
//               <div className="text-center">
//                 {/* FIX 4: Safety check before filter */}
//                 <h5 className="fw-bold mb-0 text-warning">
//                   {Array.isArray(appointments) ? appointments.filter(a => a.status === 'Pending').length : 0}
//                 </h5>
//                 <small className="text-muted">Pending</small>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* --- RIGHT CONTENT --- */}
//         <div className="col-md-8">

//           <ul className="nav nav-tabs mb-4 border-bottom-0">
//             <li className="nav-item">
//               <button className={`nav-link ${activeTab === 'appointments' ? 'active fw-bold' : 'text-muted'}`} onClick={() => setActiveTab('appointments')}>
//                 <i className="bi bi-calendar-check me-2"></i> My Appointments
//               </button>
//             </li>
//             <li className="nav-item">
//               <button className={`nav-link ${activeTab === 'settings' ? 'active fw-bold' : 'text-muted'}`} onClick={() => setActiveTab('settings')}>
//                 <i className="bi bi-gear me-2"></i> Profile Settings
//               </button>
//             </li>
//           </ul>

//           {/* TAB 1: APPOINTMENTS */}
//           {activeTab === 'appointments' && (
//             <div className="card shadow-sm border-0">
//               <div className="card-body p-0">
//                 {/* FIX 5: Safety check for length */}
//                 {!Array.isArray(appointments) || appointments.length === 0 ? (
//                   <div className="text-center py-5">
//                     <p className="text-muted">No appointments found.</p>
//                     <button className="btn btn-primary btn-sm" onClick={() => navigate('/doctors')}>Book Now</button>
//                   </div>
//                 ) : (
//                   <div className="table-responsive">
//                     <table className="table table-hover mb-0 align-middle">
//                       <thead className="table-light">
//                         <tr>
//                           <th className="ps-4">Doctor Name</th>
//                           <th>Date & Time</th>
//                           <th>Status</th>
//                           <th>Action</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {appointments.map((appt) => (
//                           <tr key={appt._id}>
//                             <td className="ps-4">
//                               <div className="fw-bold text-primary">{appt.doctorName}</div>
//                               <small className="text-muted">{appt.specialty}</small>
//                             </td>
//                             <td>
//                               <div className="fw-bold">{appt.appointmentDate}</div>
//                               <small className="text-muted">{appt.appointmentTime}</small>
//                             </td>
//                             <td>
//                               <span className={`badge ${appt.status === 'Paid' || appt.status === 'Confirmed' ? 'bg-success' : appt.status === 'Cancelled' ? 'bg-danger' : 'bg-warning text-dark'}`}>
//                                 {appt.status}
//                               </span>
//                             </td>
//                             <td>
//                               <button className="btn btn-sm btn-outline-secondary" onClick={() => openDetailsModal(appt)}>
//                                 Details
//                               </button>
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}

//           {/* TAB 2: SETTINGS */}
//           {activeTab === 'settings' && (
//             <div className="card shadow-sm border-0">
//               <div className="card-body p-4">
//                 <h5 className="fw-bold mb-4">Update Personal Information</h5>
//                 <form onSubmit={handleUpdateProfile}>
//                   <div className="mb-4 d-flex align-items-center">
//                     <div className="me-3 rounded-circle bg-light d-flex justify-content-center align-items-center overflow-hidden" style={{ width: '60px', height: '60px' }}>
//                       {formData.image ? <img src={formData.image} alt="Preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <i className="bi bi-camera"></i>}
//                     </div>
//                     <label className="btn btn-sm btn-outline-primary">
//                       Change Photo <input type="file" hidden accept="image/*" onChange={handleImageUpload} />
//                     </label>
//                   </div>

//                   <div className="row g-3">
//                     <div className="col-md-6">
//                       <label className="form-label small fw-bold">Full Name</label>
//                       <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} required />
//                     </div>
//                     <div className="col-md-6">
//                       <label className="form-label small fw-bold">Phone</label>
//                       <input type="text" className="form-control" name="phone" value={formData.phone} onChange={handleChange} />
//                     </div>
//                     <div className="col-12">
//                       <label className="form-label small fw-bold">Address</label>
//                       <input type="text" className="form-control" name="address" value={formData.address} onChange={handleChange} />
//                     </div>
//                     <div className="col-md-6">
//                       <label className="form-label small fw-bold">Gender</label>
//                       <select className="form-select" name="gender" value={formData.gender} onChange={handleChange}>
//                         <option value="">Select Gender</option>
//                         <option value="Male">Male</option>
//                         <option value="Female">Female</option>
//                       </select>
//                     </div>
//                     <div className="col-md-6">
//                       <label className="form-label small fw-bold">Date of Birth</label>
//                       <input type="date" className="form-control" name="dob" value={formData.dob} onChange={handleChange} />
//                     </div>
//                     <div className="col-12 mt-4 text-end">
//                       <button type="submit" className="btn btn-dark px-4">Save Changes</button>
//                     </div>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* === DETAILS MODAL === */}
//       {showDetailsModal && selectedAppt && (
//         <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
//           <div className="modal-dialog modal-dialog-centered">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title fw-bold">Appointment Details</h5>
//                 <button type="button" className="btn-close" onClick={() => setShowDetailsModal(false)}></button>
//               </div>
//               <div className="modal-body">
//                 <div className="text-center mb-4">
//                   <h4 className="fw-bold text-primary mb-0">{selectedAppt.doctorName}</h4>
//                   <span className="badge bg-light text-dark border">{selectedAppt.specialty}</span>
//                 </div>
//                 <ul className="list-group list-group-flush">
//                   <li className="list-group-item d-flex justify-content-between">
//                     <span>Date:</span> <strong>{selectedAppt.appointmentDate}</strong>
//                   </li>
//                   <li className="list-group-item d-flex justify-content-between">
//                     <span>Time:</span> <strong>{selectedAppt.appointmentTime}</strong>
//                   </li>
//                   <li className="list-group-item d-flex justify-content-between">
//                     <span>Consultation Fee:</span> <strong>Rs. {selectedAppt.fee || 2000}</strong>
//                   </li>
//                   <li className="list-group-item d-flex justify-content-between">
//                     <span>Status:</span>
//                     <span className={`badge ${selectedAppt.status === 'Paid' ? 'bg-success' : selectedAppt.status === 'Cancelled' ? 'bg-danger' : 'bg-warning text-dark'}`}>
//                       {selectedAppt.status}
//                     </span>
//                   </li>
//                 </ul>
//                 {selectedAppt.status === 'Pending' && (
//                   <div className="mt-4 text-center">
//                     <button className="btn btn-outline-danger w-100" onClick={() => handleCancelAppointment(selectedAppt._id)}>
//                       Cancel Appointment
//                     </button>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//     </div>
//   );
// };

// export default ProfilePage;
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { 
    FaCalendarAlt, FaFileMedical, FaPills, FaCreditCard, 
    FaUserMd, FaClock, FaEllipsisV, 
    FaCheckCircle, FaLock, FaUserCircle, FaSignOutAlt, FaCog, FaShieldAlt, FaCamera, FaPhone
} from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Required for Dropdown
import '../styles/ProfilePage.css';

const ProfilePage = () => {
  const navigate = useNavigate();
  
  // --- STATE ---
  const [user, setUser] = useState(null);
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('upcoming'); // Controls View: 'upcoming', 'completed', 'cancelled', 'settings'

  // Form State for Settings
  const [formData, setFormData] = useState({
    name: '', phone: '', address: '', gender: '', dob: '', image: ''
  });

  // --- INITIAL LOAD ---
  useEffect(() => {
    const userString = localStorage.getItem('DDoctorUser');
    if (!userString) {
      navigate('/');
      return;
    }
    const userData = JSON.parse(userString);
    setUser(userData);

    // Initialize Form Data
    setFormData({
        name: userData.name || '',
        phone: userData.phone || '',
        address: userData.address || userData.city || '',
        gender: userData.gender || '',
        dob: userData.dob || '',
        image: userData.image || ''
    });

    fetchAppointments(userData._id);
  }, [navigate]);

  // --- API FUNCTIONS ---
  const fetchAppointments = async (userId) => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/bookings/user/${userId}`);
      const list = Array.isArray(res.data) ? res.data : (res.data.data || []);
      setAppointments(list);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching appointments:", err);
      setAppointments([]); 
      setLoading(false);
    }
  };

  const handleCancelAppointment = async (apptId) => {
    if (window.confirm("Are you sure you want to cancel this appointment?")) {
      try {
        await axios.put(`${process.env.REACT_APP_API_BASE_URL}/bookings/cancel/${apptId}`);
        alert("Appointment cancelled successfully.");
        fetchAppointments(user._id); // Refresh data
      } catch (err) {
        alert("Failed to cancel appointment.");
      }
    }
  };

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    try {
        const res = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/users/update/${user._id}`, formData);
        alert("Profile Updated Successfully!");
        const updatedUser = res.data.user || res.data;
        localStorage.setItem('DDoctorUser', JSON.stringify(updatedUser));
        setUser(updatedUser);
    } catch (err) {
        alert("Error updating profile.");
    }
  };

  // --- HELPER FUNCTIONS ---
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => setFormData({ ...formData, image: reader.result });
    }
  };

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const getStatusBadge = (status) => {
      const s = status ? status.toLowerCase() : 'pending';
      if(s === 'confirmed' || s === 'paid' || s === 'approved') return <span className="badge bg-success bg-opacity-10 text-success">Confirmed</span>;
      if(s === 'cancelled' || s === 'rejected') return <span className="badge bg-danger bg-opacity-10 text-danger">Cancelled</span>;
      if(s === 'completed' || s === 'visited') return <span className="badge bg-primary bg-opacity-10 text-primary">Completed</span>;
      return <span className="badge bg-warning bg-opacity-10 text-warning text-dark">Pending</span>;
  };

  // --- FILTER LOGIC ---
  const filteredAppointments = appointments.filter(appt => {
      const status = appt.status ? appt.status.toLowerCase() : 'pending';
      if (activeTab === 'upcoming') return ['pending', 'paid', 'confirmed', 'approved'].includes(status);
      if (activeTab === 'completed') return ['completed', 'visited'].includes(status);
      if (activeTab === 'cancelled') return ['cancelled', 'rejected'].includes(status);
      return false; 
  });

  if (!user) return null;

  return (
    <div className="dashboard-container py-4">
      <div className="container">
        <div className="row g-4">

          {/* ==================== LEFT COLUMN (Main Content) ==================== */}
          <div className="col-lg-8">

            {/* 1. WELCOME BANNER */}
            <div className="welcome-banner mb-4 d-flex justify-content-between align-items-center shadow-sm">
              <div>
                <h2 className="mb-1 text-white">Hello, {user.name.split(' ')[0]}! 👋</h2>
                <p className="mb-4 opacity-75 text-white">Your health journey continues. What would you like to do?</p>
                <button className="btn-light-action" onClick={() => navigate('/doctors')}>
                  <FaUserMd className="me-2" /> Find & Book a Doctor
                </button>
              </div>
              <div className="d-none d-md-block opacity-50 text-white">
                <FaFileMedical size={80} />
              </div>
            </div>

            {/* 2. QUICK ACTIONS */}
            <div className="row g-3 mb-4">
              <div className="col-6 col-md-3">
                <div className="quick-action-card" onClick={() => setActiveTab('upcoming')}>
                  <div className="icon-box bg-primary bg-opacity-10 text-primary"><FaCalendarAlt /></div>
                  <h6 className="fw-bold mb-0">Appointments</h6>
                </div>
              </div>
              <div className="col-6 col-md-3">
                <div className="quick-action-card" onClick={() => navigate('/medical-records')}>
                  <div className="icon-box bg-success bg-opacity-10 text-success"><FaFileMedical /></div>
                  <h6 className="fw-bold mb-0">Records</h6>
                </div>
              </div>
              <div className="col-6 col-md-3">
                <div className="quick-action-card" onClick={() => navigate('/prescriptions')}>
                  <div className="icon-box bg-danger bg-opacity-10 text-danger"><FaPills /></div>
                  <h6 className="fw-bold mb-0">Medicines</h6>
                </div>
              </div>
              <div className="col-6 col-md-3">
                <div className="quick-action-card" onClick={() => navigate('/discount-card')}>
                  <div className="icon-box bg-warning bg-opacity-10 text-warning"><FaCreditCard /></div>
                  <h6 className="fw-bold mb-0">D-Card</h6>
                </div>
              </div>
            </div>

            {/* 3. DYNAMIC CONTENT AREA (Tabs or Settings) */}
            <div className="card border-0 shadow-sm rounded-4 bg-white">
              <div className="card-header bg-white border-0 pt-4 px-4">
                
                {/* Header Title */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="fw-bold mb-0">
                      {activeTab === 'settings' ? 'Profile Settings' : 'My Appointments'}
                  </h5>
                  {activeTab !== 'settings' && (
                      <button className="btn btn-sm btn-link text-decoration-none" onClick={() => navigate('/doctors')}>Book New</button>
                  )}
                </div>

                {/* Navigation Pills (Only show if NOT in settings mode) */}
                {activeTab !== 'settings' && (
                    <ul className="nav nav-pills">
                    <li className="nav-item">
                        <button className={`nav-link ${activeTab === 'upcoming' ? 'active' : ''}`} onClick={() => setActiveTab('upcoming')}>Upcoming</button>
                    </li>
                    <li className="nav-item">
                        <button className={`nav-link ${activeTab === 'completed' ? 'active' : ''}`} onClick={() => setActiveTab('completed')}>Past</button>
                    </li>
                    <li className="nav-item">
                        <button className={`nav-link ${activeTab === 'cancelled' ? 'active' : ''}`} onClick={() => setActiveTab('cancelled')}>Cancelled</button>
                    </li>
                    </ul>
                )}
              </div>

              <div className="card-body px-4 pb-4">
                
                {/* --- VIEW 1: APPOINTMENTS LIST --- */}
                {activeTab !== 'settings' && (
                    <>
                        {loading ? (
                            <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>
                        ) : filteredAppointments.length > 0 ? (
                        <div className="d-flex flex-column gap-3">
                            {filteredAppointments.map(appt => (
                            <div key={appt._id} className="card p-3 border-0 shadow-sm appointment-card" style={{borderLeft: '4px solid #282561'}}>
                                <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center gap-3">
                                    <div className="bg-light rounded-circle p-3 text-secondary"><FaUserMd size={20} /></div>
                                    <div>
                                    <h6 className="fw-bold mb-1">{appt.doctorName}</h6>
                                    <small className="text-muted">{appt.specialty} • {appt.hospital}</small>
                                    </div>
                                </div>
                                <div className="text-end d-none d-sm-block">
                                    <div className="fw-bold text-dark"><FaClock className="me-1 text-muted" /> {appt.appointmentTime}</div>
                                    <small className="text-muted">{appt.appointmentDate}</small>
                                </div>
                                </div>
                                <div className="mt-3 d-flex justify-content-between align-items-center border-top pt-2">
                                {getStatusBadge(appt.status)}
                                {activeTab === 'upcoming' && (
                                    <button className="btn btn-sm btn-outline-danger" onClick={() => handleCancelAppointment(appt._id)}>Cancel</button>
                                )}
                                </div>
                            </div>
                            ))}
                        </div>
                        ) : (
                        <div className="text-center py-5 text-muted">
                            <FaCalendarAlt size={40} className="mb-3 opacity-25" />
                            <p>No {activeTab} appointments found.</p>
                        </div>
                        )}
                    </>
                )}

                {/* --- VIEW 2: PROFILE SETTINGS FORM --- */}
                {activeTab === 'settings' && (
                    <form onSubmit={handleUpdateProfile}>
                        <div className="text-center mb-4">
                            <div className="position-relative d-inline-block">
                                <div className="rounded-circle overflow-hidden bg-light" style={{width:'100px', height:'100px'}}>
                                    {formData.image ? 
                                        <img src={formData.image} alt="Profile" style={{width:'100%', height:'100%', objectFit:'cover'}}/> : 
                                        <FaUserCircle size={100} className="text-secondary"/>
                                    }
                                </div>
                                <label className="position-absolute bottom-0 end-0 bg-primary text-white p-2 rounded-circle cursor-pointer" style={{cursor:'pointer'}}>
                                    <FaCamera size={14}/>
                                    <input type="file" hidden accept="image/*" onChange={handleImageUpload} />
                                </label>
                            </div>
                        </div>

                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="form-label small fw-bold">Full Name</label>
                                <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} required />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label small fw-bold">Phone</label>
                                <input type="text" className="form-control" name="phone" value={formData.phone} onChange={handleChange} />
                            </div>
                            <div className="col-12">
                                <label className="form-label small fw-bold">Address</label>
                                <input type="text" className="form-control" name="address" value={formData.address} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label small fw-bold">Gender</label>
                                <select className="form-select" name="gender" value={formData.gender} onChange={handleChange}>
                                    <option value="">Select</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                </select>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label small fw-bold">Date of Birth</label>
                                <input type="date" className="form-control" name="dob" value={formData.dob} onChange={handleChange} />
                            </div>
                            <div className="col-12 mt-4 text-end">
                                <button type="button" className="btn btn-light me-2" onClick={() => setActiveTab('upcoming')}>Cancel</button>
                                <button type="submit" className="btn btn-primary px-4 fw-bold">Save Changes</button>
                            </div>
                        </div>
                    </form>
                )}

              </div>
            </div>
          </div>

          {/* ==================== RIGHT COLUMN (Professional Sidebar) ==================== */}
          <div className="col-lg-4">

            {/* 1. PROFESSIONAL PROFILE WIDGET */}
            <div className="card border-0 shadow-sm rounded-4 mb-4 overflow-hidden bg-white">
              {/* Header Background */}
              <div className="bg-light p-4 text-center border-bottom position-relative">
                <div className="d-inline-block position-relative mb-2">
                  <div className="rounded-circle bg-white p-1 shadow-sm">
                    <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center fw-bold"
                      style={{ width: 70, height: 70, fontSize: '1.5rem' }}>
                      {user.name ? user.name.charAt(0).toUpperCase() : 'U'}
                    </div>
                  </div>
                  <span className="position-absolute bottom-0 end-0 p-2 bg-success border border-2 border-white rounded-circle"></span>
                </div>
                <h5 className="fw-bold mb-0 text-dark text-capitalize">{user.name}</h5>
                <small className="text-muted">{user.email}</small>

                {/* Settings Gear (Absolute Position) */}
                <button className="btn btn-sm btn-light position-absolute top-0 end-0 m-3 rounded-circle shadow-sm"
                  onClick={() => setActiveTab('settings')} title="Settings">
                  <FaCog className="text-muted" />
                </button>
              </div>

              {/* Stats Row (Dynamic Data) */}
              <div className="d-flex border-bottom">
                <div className="flex-fill p-3 text-center border-end hover-bg-light">
                  <h5 className="fw-bold mb-0 text-dark">{appointments.length}</h5>
                  <small className="text-muted" style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Bookings</small>
                </div>
                <div className="flex-fill p-3 text-center hover-bg-light">
                  <h5 className="fw-bold mb-0 text-warning">
                      {appointments.filter(a => ['pending', 'paid', 'confirmed'].includes(a.status?.toLowerCase())).length}
                  </h5>
                  <small className="text-muted" style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Active</small>
                </div>
              </div>

              {/* Logout Action */}
              <div className="p-2">
                <button className="btn btn-link text-danger text-decoration-none w-100 fw-bold btn-sm"
                  onClick={() => { localStorage.clear(); navigate('/'); }}>
                  <FaSignOutAlt className="me-2" /> Sign Out
                </button>
              </div>
            </div>

            {/* 2. PREMIUM MEMBERSHIP CARD (Redesigned) */}
            {user.hasDiscountCard ? (
              // Active Member View
              <div className="premium-card mb-4 p-4 rounded-4 text-white shadow position-relative overflow-hidden"
                style={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)' }}>
                <div className="d-flex justify-content-between align-items-start mb-4">
                  <div>
                    <small className="opacity-50 fw-bold" style={{ fontSize: '10px' }}>MEMBERSHIP STATUS</small>
                    <div className="badge bg-warning text-dark mt-1">GOLD TIER</div>
                  </div>
                  <FaCheckCircle className="opacity-50" size={24} />
                </div>
                <h5 className="mb-1" style={{ fontFamily: 'monospace', letterSpacing: '2px' }}>•••• •••• •••• 4291</h5>
                <div className="d-flex justify-content-between mt-4 align-items-end">
                  <span className="fw-bold small">{user.name}</span>
                  <span className="small opacity-75">Exp: 12/26</span>
                </div>
              </div>
            ) : (
              // Upgrade Call to Action
              <div className="card border-0 rounded-4 mb-4 shadow-sm position-relative overflow-hidden"
                style={{ background: 'linear-gradient(135deg, #232526 0%, #414345 100%)' }}>

                {/* Abstract Shapes for "Premium" feel */}
                <div className="position-absolute top-0 end-0 bg-warning opacity-10 rounded-circle" style={{ width: 100, height: 100, transform: 'translate(30%, -30%)' }}></div>

                <div className="card-body p-4 text-white text-center position-relative z-1">
                  <div className="mb-3 d-inline-block p-3 rounded-circle bg-white bg-opacity-10 backdrop-blur">
                    <FaLock className="text-warning" size={24} />
                  </div>
                  <h5 className="fw-bold mb-1">Upgrade to Gold</h5>
                  <p className="small opacity-75 mb-3">Get 40% OFF on all labs & hospitals.</p>

                  <button className="btn btn-warning w-100 fw-bold text-dark shadow-lg border-0"
                    onClick={() => navigate('/discount-card')}>
                    Unlock Now for Rs. 5000
                  </button>
                </div>
              </div>
            )}

            {/* 3. SUBTLE HEALTH TIP */}
            <div className="d-flex align-items-start p-3 bg-white border rounded-4 shadow-sm">
              <div className="flex-shrink-0">
                <FaCheckCircle className="text-success mt-1" size={18} />
              </div>
              <div className="flex-grow-1 ms-3">
                <h6 className="fw-bold small mb-1 text-dark">Daily Wellness Tip</h6>
                <p className="text-muted small mb-0 fst-italic lh-sm">
                  "Hydration is key! Aim for 8 glasses of water daily to maintain energy."
                </p>
              </div>
            </div>

            {/* 4. TRUST BADGE */}
            <div className="mt-4 text-center opacity-50">
              <small className="fw-bold" style={{ fontSize: '10px', letterSpacing: '1px' }}>
                <FaShieldAlt className="me-1" /> 256-BIT SECURE ENCRYPTION
              </small>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;